import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

import { computed, inject } from 'vue';
import { useRoute } from 'vue-router';
import { configurationKey } from '@/injections';
import useEmployee from '@/modules/employee/composables/useEmployee';
import WCDesktopOTSwitcher from '@/components/WCDesktopOTSwitcher/WCDesktopOTSwitcher.vue';
import WCDesktopSubNavbar from '../WCDesktopSubNavbar/WCDesktopSubNavbar.vue';

interface Props {
  wcHeaderHeight?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WCDesktopNavBarModern',
  props: {
    wcHeaderHeight: { default: '0px' }
  },
  setup(__props: any) {



const route = useRoute();
const { isNotAnEmployee } = useEmployee();
const configuration = inject(configurationKey);

const orderTypesEnabled = computed(() => configuration?.orderTypesEnabled);

return (_ctx: any,_cache: any) => {
  return (_unref(isNotAnEmployee) && _unref(route).name !== 'Gift Card')
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        (orderTypesEnabled.value)
          ? (_openBlock(), _createBlock(WCDesktopOTSwitcher, { key: 0 }))
          : _createCommentVNode("", true),
        _cache[0] || (_cache[0] = _createTextVNode()),
        _createVNode(WCDesktopSubNavbar, { wcHeaderHeight: _ctx.wcHeaderHeight }, null, 8, ["wcHeaderHeight"])
      ]))
    : _createCommentVNode("", true)
}
}

})